export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="https://public.readdy.ai/ai/img_res/fee6f257-a6b0-4dc8-ba03-57e6b89bb139.png" alt="SURGEN Logo" className="h-8 w-8" />
              <span className="text-2xl font-bold">SURGEN</span>
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Protecting your digital privacy
            </p>
            <p className="text-sm text-gray-400 leading-relaxed">
              Committed to providing secure, private internet access for everyone
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                  How It Works
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Support</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('support')} className="text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Help Center
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </button>
              </li>
              <li>
                <a href="mailto:support@surgensrl.com" className="text-base text-gray-300 hover:text-white transition-colors">
                  Email Support
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <a href="#" className="text-base text-gray-300 hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-base text-gray-300 hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2025 SURGEN S.R.L. All rights reserved
            </div>

            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 border border-gray-700 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 hover:border-transparent transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-gray-400 hover:text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-gray-700 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 hover:border-transparent transition-all cursor-pointer">
                <i className="ri-facebook-fill text-gray-400 hover:text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-gray-700 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 hover:border-transparent transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-gray-400 hover:text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-gray-700 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 hover:border-transparent transition-all cursor-pointer">
                <i className="ri-instagram-line text-gray-400 hover:text-white"></i>
              </a>
            </div>

            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors">Terms</a>
              <span>|</span>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
